import { Button, TimePicker, Flex } from "antd";
import { useState } from "react";
import { PlusCircleOutlined } from "@ant-design/icons";
import { Dayjs } from "dayjs";
import { useTranslation } from "react-i18next";
import useAvailability from "../../hooks/useAvailability";

const AddTime = (props: { day: string }) => {
  const { t } = useTranslation();
  const { day } = props;
  const [time, setTime] = useState<[start: Dayjs | null, end: Dayjs | null] | null>(null);
  const { addAvailability } = useAvailability();

  return (
    <Flex gap={8}>
      <TimePicker.RangePicker
        inputReadOnly
        format="HH"
        variant="borderless"
        size="small"
        suffixIcon
        value={time}
        allowClear={false}
        placeholder={[
          t("availabilityPage.availability.placeholderFrom"),
          t("availabilityPage.availability.placeholderTo")
        ]}
        onChange={(value) => setTime(value)}
        style={{ flexGrow: 1 }}
      />
      <Button
        type="text"
        onClick={() => {
          if (time && time[0] && time[1]) {
            addAvailability(
              day,
              time[0].format("HH:mm"),
              time[1].format("HH:mm")
            );
            setTime(null);
          }
        }}
        disabled={!time}
        icon={<PlusCircleOutlined />}
      />
    </Flex>
  );
};

export default AddTime;
